/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

//Import PageHeader
import PageHeader from "../../components/PageHeader";

import { useHistory } from "react-router";
// Redux Store
import queryString from "query-string";
import { shallowEqual, useSelector } from "react-redux";
import { get } from "lodash";
import CareCompanyInfo from "../../components/CareCompany/CareCompanyInfo";
import CareCompanySchedule from "../../components/CareCompany/CareCompanySchedule";
import Loading from "../../components/Loading";
import { getCareCompany } from "../../apis/admin/companies";

const Company = () => {
  const history = useHistory();
  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );
  const [company, setCompany] = useState(null)
  const [targetCompanyIdx, setTargetCompanyIdx] = useState(null);
  const [activeTab, setActiveTab] = useState();
  const _setActiveTab = (value) => {
    history.push({
      search: `?targetCompanyIdx=${targetCompanyIdx}&tab=${value}`
    })
    setActiveTab(value)
  }

  const [tabList, setTabList] = useState([])
  useEffect(() => {
    setTabList([
      {
        label: "고객 정보 관리",
        action: _setActiveTab,
        value: 'info',
      },
      // {
      //   label: "담당자 상담",
      //   action: _setActiveTab,
      //   value: 'taxBoard',
      // },
      {
        label: "일정 메모",
        action: _setActiveTab,
        value: 'scheduleMemo',
      }
    ])
  }, [targetCompanyIdx])

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    const _targetCompanyIdx = query.targetCompanyIdx
    if (_targetCompanyIdx && user) {
      setTargetCompanyIdx(_targetCompanyIdx)
      setActiveTab(query.tab || 'info');
      getCareCompany(user.managerCompanyIdx, user.type, _targetCompanyIdx)
        .then((data) => {
          const _company = get(data, "data.company")
          setCompany(_company)
        })

    }
  }, [history.location, user]);

  return (
    <>
      {company &&
        <PageHeader
          title={`${company && company.name}`}
          activeTab={activeTab}
          tabList={tabList}
        />
      }
      {company ?
        <>
          {
            (activeTab === 'info' || !activeTab) &&
            <CareCompanyInfo company={company} setCompany={setCompany}></CareCompanyInfo>
          }
          {
            (activeTab === 'scheduleMemo') &&
            <CareCompanySchedule company={company} setCompany={setCompany}></CareCompanySchedule>
          }
        </>
        : <><Loading></Loading></>
      }
    </>
  );
};

export default Company;
